import { compose } from 'recompose';

import VariantShow from './VariantShow';

const enhance = compose();

export default enhance(VariantShow);
